import { useEffect } from "react";

const SCHEMA = {
  "@context": "https://schema.org",
  "@type": "AutoRepair",
  name: "Veteran's Auto Repair Center",
  legalName: "Veteran's Auto Repair Center LLC",
  image:
    "https://images.unsplash.com/photo-1771340012378-3c86cb649193?w=1200",
  description:
    "Veteran-owned full-service auto repair shop in Madison Heights, MI. Honest pricing, ASE-certified mechanics, same-day service.",
  url: typeof window !== "undefined" ? window.location.origin : "",
  telephone: "+1-248-439-0036",
  email: "veteransautorepair@outlook.com",
  priceRange: "$$",
  address: {
    "@type": "PostalAddress",
    streetAddress: "1222 E 11 Mile Rd",
    addressLocality: "Madison Heights",
    addressRegion: "MI",
    postalCode: "48071",
    addressCountry: "US",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 42.4884,
    longitude: -83.1054,
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "08:00",
      closes: "18:00",
    },
  ],
  areaServed: [
    "Madison Heights",
    "Warren",
    "Royal Oak",
    "Troy",
    "Sterling Heights",
    "Hazel Park",
    "Ferndale",
    "Metro Detroit",
  ],
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "5.0",
    reviewCount: "5",
  },
  makesOffer: [
    "Brake Repair",
    "Oil Changes",
    "Engine Diagnostics",
    "Transmission Repair",
    "Suspension & Steering",
    "Battery Replacement",
    "Heating & Cooling",
    "Full Vehicle Inspection",
  ],
};

const SCRIPT_ID = "vet-local-business-jsonld";

export default function SchemaMarkup() {
  useEffect(() => {
    let el = document.getElementById(SCRIPT_ID);
    if (!el) {
      el = document.createElement("script");
      el.id = SCRIPT_ID;
      el.type = "application/ld+json";
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(SCHEMA);
    return () => {
      const existing = document.getElementById(SCRIPT_ID);
      if (existing) existing.remove();
    };
  }, []);
  return null;
}
